module.exports = __webpack_public_path__ + "img/step25_printer_basic_route_cables.6e536793.png";